declare namespace $ {

	export class $mol_icon_application extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=application.view.tree.d.ts.map